<template>
  <div>
    <AppFamilyMember />

    <CModal
      color="danger"
      closeOnBackdrop
      :centered="true"
      :show.sync="errorModal"
    >
      <p>{{ errorMessage }}</p>
      <template #header>
        <h4 class="modal-title">Error</h4>
      </template>
      <template #footer>
        <CButton @click="errorModal = false" color="secondary">
          <i class="icon cil-x"></i> 閉じる
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
// import Vue from 'vue'
// import axios from "axios";
import AppFamilyMember from "../../components/AppFamilyMember";
// import Options from "../../components/Options";




export default {
  components: {
    AppFamilyMember,
  },
  name: "UserFamily",

};
</script>
